/*
  Draw a border around an object
  - This border is not a normal css border, the lines extend INSIDE the boundaries of the object
    rather than outside like in the common css box-model
  - Used to draw borders around the template
  - Used to draw borders around a widget
  - Used to display ephemoral border around currently hovered widget
*/
function createLineItems(width, height, borderWidth, borderColor, borderCustomStyle, pivot) {
  if (!width || !height || !borderWidth || !borderColor) {
    return []
  }

  borderWidth = Math.min(borderWidth, Math.min(width, height))

  // This is the origin (left,top) of the box
  // plo todo - rename this to origin everywhere
  const { x, y } = pivot

  // Define border lines, that is, the lines at all four sides that make up a box (north, east, south, west)
  const borderLines = [
    {
      left: `${x}px`,
      top: `${y}px`,
      width: `${width}px`,
      height: `${borderWidth}px`,
    },
    {
      left: `${x + width - borderWidth}px`,
      top: `${y}px`,
      width: `${borderWidth}px`,
      height: `${height}px`,
    },
    {
      left: `${x}px`,
      top: `${y + height - borderWidth}px`,
      width: `${width}px`,
      height: `${borderWidth}px`,
    },
    {
      left: `${x}px`,
      top: `${y}px`,
      width: `${borderWidth}px`,
      height: `${height}px`,
    },
  ]
  borderLines.map(l =>
    Object.assign(
      l,
      {
        position: 'absolute',
        // we have to use specific css color to allow styles to be overriden by border-custom-style
        'background-color': borderColor,
      },
      borderCustomStyle
    )
  )

  return borderLines
}

function sanitizeNumber(input, fallback) {
  return !input || typeof input !== 'number' ? fallback : input
}

const Z_INDEX_DEFAULT = 500

export default {
  name: 'faux-border',
  props: {
    className: {
      type: String,
      default() {
        return ''
      },
    },
    width: Number,
    height: Number,

    borderWidth: Number,
    borderColor: {
      type: String,
      default: 'gold',
    },

    borderCustomStyle: {
      type: Object,
      default() {
        return {}
      },
    },

    zIndex: {
      type: Number,
      default: Z_INDEX_DEFAULT,
    },
    zModifier: {
      type: Number,
      default: 0,
    },

    pivot: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0,
        }
      },
    },
  },
  render($h) {
    const lineWidgets = createLineItems(
      this.width,
      this.height,
      this.borderWidth,
      this.borderColor,
      this.borderCustomStyle,
      this.pivot
    ).map(lineItem =>
      $h('div', {
        style: lineItem,
      })
    )

    return $h(
      'div',
      {
        class: this.className,
        style: {
          'pointer-events': 'none',
          position: 'absolute',
          width: '100%',
          height: '100%',
          'z-index': sanitizeNumber(this.zIndex, Z_INDEX_DEFAULT) + (this.zModifier || 0),
        },
      },
      lineWidgets
    )
  },
}
